import { authHeader,logout, handleResponse } from '../helpers';
import Vue from 'vue';


export const proizvodService = {
    load,loadAll,save,remove,loadPreteklaSezona
    
};

function load(sezona,pridelovalecid,vrsta) {
    const requestOptions = {
        method: 'GET',
        headers:authHeader(),
        
    };


    return fetch(`${Vue.prototype.$config.apiUrl}/proizvod/?sezona=${sezona}&pridelovalecid=${pridelovalecid}&vrsta=${vrsta}`, requestOptions)
        .then(handleResponse)
        .then(proizvod => {
            // login successful if there's a jwt token in the response
            
            return proizvod;
        });
}

function loadPreteklaSezona(sezona,pridelovalecid,vrsta) {
    const requestOptions = {
        method: 'GET',
        headers:authHeader(),
        
    };


    return fetch(`${Vue.prototype.$config.apiUrl}/proizvod/preteklasezona/?sezona=${sezona}&pridelovalecid=${pridelovalecid}&vrsta=${vrsta}`, requestOptions)
        .then(handleResponse)
        .then(proizvod => {
            // login successful if there's a jwt token in the response
            
            return proizvod;
        });
}


function save(proizvod,vrsta) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json',...authHeader()},
        body: JSON.stringify(proizvod)
    };

    return fetch(`${Vue.prototype.$config.apiUrl}/proizvod/?vrsta=${vrsta}`, requestOptions).then(handleResponse);
}


function remove(proizvod,vrsta) {
    const requestOptions = {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json',...authHeader()},
        body: JSON.stringify(proizvod)
    };

    return fetch(`${Vue.prototype.$config.apiUrl}/proizvod/?vrsta=${vrsta}`, requestOptions).then(handleResponse);
}

function loadAll(sezona,vrsta){
  const requestOptions = {
        method: 'GET',
        headers:authHeader(),
        
    };


     return fetch(`${Vue.prototype.$config.apiUrl}/proizvod/vsi/?sezona=${sezona}&vrsta=${vrsta}`, requestOptions)
        .then(handleResponse)
        .then(proizvod => {
            // login successful if there's a jwt token in the response
            
            return proizvod;
        });
}

function loadLastYear(gerk,status,vrsta){
    //in tu lahko napišem pravila ali pa jih enostavno potegnem iz baze preko api-ja
    return fetch(`${Vue.prototype.$config.apiUrl}/proizvod/?sezona=${sezona}&pridelovalecid=${pridelovalecid}`, requestOptions)
        .then(handleResponse)
        .then(proizvod => {
            // login successful if there's a jwt token in the response
            
            return proizvod;
        });

}
